<ion-item>
  <ion-label>{{ label }}</ion-label>
  <ion-checkbox [name]="id" (ionChange)="select($event)" [checked]="item.checked"></ion-checkbox>
</ion-item>
